
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/ams",
      function () {
        return require("private-next-pages/destinations/ams.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/ams"])
      });
    }
  